import { HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent, HttpErrorResponse } from "@angular/common/http";

import { Router } from '@angular/router';

import { Injectable, Injector, inject } from '@angular/core';
import { catchError } from 'rxjs/operators';

import {throwError as observableThrowError, Observable, EMPTY} from 'rxjs';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private injector = inject(Injector);
  private router = inject(Router);


  currentUrl = "/";

  constructor() {
    const router = this.router;

    this.currentUrl = router.routerState.snapshot.url;
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<unknown> | HttpUserEvent<unknown>> {

    return next.handle(req).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.url?.endsWith('account/session')) {
            return next.handle(req);
          }
          const status = (<HttpErrorResponse>error).status;
          if (status === 401 && !window.location.pathname.startsWith('/account')) {
            // This is not the cleanest solution but we often have spinners, stored data, it is better to restart from a clean slate
            window.location.href = `/account/login${window.location.pathname ? `?returnUrl=${encodeURIComponent(window.location.pathname)}` : ''}`;
            // this.router.navigate([], {queryParams: {returnUrl: window.location.pathname}});
            return EMPTY;
          }
        }
        if (error.error && error.error.UserMessage) {
          switch (error.error.UserMessage) {
            case 'Account lockedout.':
              this.router.navigate(['/error/client/1']);
              break;
            case 'Account lockedout with reset.':
              this.router.navigate(['/error/client/3']);
              break;
            case 'Invalid token. Password Changed.':
              this.router.navigate(['/error/client/passwordChanged']);
              break;
            case 'TemporaryDownTime':
              if (error.status == 401) this.logoutUser(error);
              break;
            default:
              break;
          }
        } else if (error instanceof HttpErrorResponse) {
          switch ((<HttpErrorResponse>error).status) {
            case 400:
              return this.handle400Error(error);
            case 401:
              this.logoutUser(error);
              return observableThrowError(error);
            default:
               return observableThrowError(error);
          }
        }
        return observableThrowError(error);
      }));
  }

  handle400Error(error: HttpErrorResponse) {
    if (error && error.status === 400 && error.error && error.error.error === 'invalid_grant') {
        // If we get a 400 and the error message is 'invalid_grant', the token is no longer valid so logout.
        return this.logoutUser(error);
    }
    return observableThrowError(error);
  }

  logoutUser(error: unknown) {
    //if (this.currentUrl.indexOf('/account/login') === -1)
    this.router.navigate(['/account/login']/*, { queryParams: { returnUrl: this.currentUrl}}*/);
    return observableThrowError(error);
  }


}


